import React, { useEffect, useState } from 'react';

const SettlementRejectedList = ({ onClose }) => {
  const [rejectedList, setRejectedList] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchRejectedData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}settlement_rejected_list`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await response.json();
        setRejectedList(result.data || []);
        setFilteredResults(result.data || []);
      } catch (error) {
        console.error('Error fetching rejected list:', error);
        setRejectedList([]);
        setFilteredResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedData();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = rejectedList.filter((item) =>
      item.emp_code?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredResults(filtered);
    setCurrentPage(1); // reset to first page on new search
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredResults.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredResults.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: 'rgba(0,0,0,0.85)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100%',
        zIndex: 1050,
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
      }}
    >
      <div
        className="modal-dialog"
        role="document"
        style={{
          width: '95vw',
          height: '90vh',
          marginLeft: '720px',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className="modal-content shadow-lg"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Rejected Settlement List</h5>
            <button
              type="button"
              className="close text-white"
              onClick={onClose}
              style={{ fontSize: '1.5rem', background: 'none', border: 'none' }}
            >
              &times;
            </button>
          </div>

          <div
            className="modal-body"
            style={{
              overflowY: 'auto',
              overflowX: 'auto',
              flex: 1,
              padding: '1rem',
            }}
          >
            <div className="form-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Emp Code..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>

            {loading ? (
              <p>Loading...</p>
            ) : filteredResults.length === 0 ? (
              <p>No rejected items found.</p>
            ) : (
              <div style={{ minWidth: '100px' }}>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped table-hover">
                    <thead className="thead-dark">
                      <tr>
                        <th>Emp Code</th>
                        <th>Employee</th>
                        <th>Audit Remarks</th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item) => (
                        <tr key={item.id}>
                          <td>{item.emp_code}</td>
                          <td>{item.comp_name}</td>
                          
                          <td>
                            {item.audit_remarks}
                          </td> 
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-dark" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettlementRejectedList;
